import * as yup from 'yup'

export const isaacLinkSchema = yup.object().shape({
  title: yup.string().required('Title Description field is required.'),
  url: yup
    .string()
    .required('Local Isaac Link field is required.')
    .url('Please enter a valid URL.')
})
